module.exports = __webpack_public_path__ + "static/assets/ce8a3a5ea17b257d8e2a699129c8997a.png";